import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';
import { constructUrl } from '../utils/constructUrl';

const getRootUrl = (url) => {
	return url.toString().replace(/^(.*\/\/[^/?#]*).*$/, '$1');
};

const SEO = ({ type, pathname, title, description, image } = {}) => {
	const {
		site: { siteMetadata },
		i18NJson: i18n,
		ogImageDefault,
	} = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
					siteUrl
					locale
					social {
						fbAppId
						twitterId
					}
				}
			}
			i18NJson {
				titles {
					_default
				}
				descriptions {
					_default
				}
			}
			# share image default
			ogImageDefault: file(relativePath: { eq: "shareDefault.png" }) {
				childImageSharp {
					gatsbyImageData(layout: FIXED)
				}
			}
		}
	`);

	const baseUrl =
		typeof window !== 'undefined'
			? getRootUrl(window.location.href)
			: siteMetadata.siteUrl;

	const siteName = siteMetadata.title;

	const locale = siteMetadata.locale;

	const fbAppId = siteMetadata.social.fbAppId;
	const twitterId = siteMetadata.social.twitterId;

	const metaType = type ?? 'article';
	const metaUrl = constructUrl(baseUrl, pathname);
	const metaTitle = title ?? i18n.titles._default;
	const metaDescription = description ?? i18n.descriptions._default;
	const metaImage = constructUrl(baseUrl, image ?? getSrc(ogImageDefault));

	return (
		<Helmet
			htmlAttributes={{ locale }}
			title={metaTitle}
			titleTemplate={`%s | ${siteMetadata.title}`}
			meta={[
				{ name: 'description', content: metaDescription },
				{ property: 'og:site_name', content: siteName },
				{ property: 'og:url', content: metaUrl },
				{ property: 'og:type', content: metaType },
				{ property: 'og:title', content: metaTitle },
				{ property: 'fb:app_id', content: fbAppId },
				{ property: 'og:description', content: metaDescription },
				{ property: 'og:locale', content: locale },
				{ property: 'og:image', content: metaImage },

				{ property: 'twitter:site', content: twitterId },
				{ property: 'twitter:title', content: metaTitle },
				{ property: 'twitter:description', content: metaDescription },
				{ property: 'twitter:card', content: 'summary_large_image' },
				{ property: 'twitter:image', content: metaImage },
			]}
		/>
	);
};

export default SEO;
